import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.043 9.00004L6.25009 14.7929C5.9351 15.1079 6.15819 15.6465 6.60364 15.6465L18.1894 15.6465C18.6349 15.6465 18.858 15.1079 18.543 14.7929L12.7501 9.00004C12.5548 8.80478 12.2382 8.80477 12.043 9.00004Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgTriangleUp;
